module.exports = __webpack_public_path__ + "static/img/Fruit.9fcd260.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Fruit.png
// module id = 2236
// module chunks = 61